import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { GoogleTagManagerService } from './google-tag-manager.service';

@Injectable()
export class AnalyticsService {
    constructor(private gtmService: GoogleTagManagerService, private router: Router) {}

    pageView(overridePath?: string) {
        this.gtmService.pushTag({
            event: 'page',
            pageURL: overridePath || this.router.url,
        });
    }
}
